import styled from 'styled-components/native';

export default styled.Text<{ isActive?: boolean }>`
  color: ${({ theme }) => theme.marketplace.decoratedTitleText};
  opacity: ${({ isActive }) => (isActive ? '1' : '0.65')};
  font-family: BasierCircle-Regular;
  font-size: 15px;
`;
